'use client';
import { useEffect, useState } from 'react';

import { useAtomValue } from 'jotai';

import { Ad } from '@ads/Components/Ad/Ad';
import { CarFinanceAd } from '@ads/Components/Ad/CarFinance/CarFinance';
import { buildPlpTargeting } from '@ads/Utils/BuildPlpTargeting';
import { tenantAtom } from '@core/Atoms/Tenant/Tenant.atom';
import { isWindowDefined } from '@core/Constants/Window';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

import styles from './AdsPanel.module.css';

export const AdsPanelClient = ({ filters }: { filters: Filter[] }) => {
  const [shouldShowAds, setShouldShowAds] = useState(false);
  const tenant = useAtomValue(tenantAtom);

  useEffect(() => {
    if (isWindowDefined) {
      setShouldShowAds(true);
    }
  }, []);

  const plpAdTargeting = buildPlpTargeting(filters);

  return (
    <>
      {shouldShowAds && plpAdTargeting ? (
        <div className={styles.panelAds}>
          <Ad unitId="plpDmpu1" targeting={plpAdTargeting} stickyPadding={500} />
          {tenant && (
            <div className={styles.carFinanceWidget}>
              <CarFinanceAd />
            </div>
          )}
          <div className={styles.plpDmpuAdContainer}>
            <div className={styles.plpDmpuAd}>
              <Ad unitId="plpDmpu2" targeting={plpAdTargeting} withMargin />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
